import { Link } from "react-router-dom";
import { Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import HomeContainer from "../HomeContainer/HomeContainer";
import "swiper/css";
import "swiper/css/pagination";
import "./HeroSlider.css";


export default function HeroSlider({

    slides = []

}) {

  //  console.log("Slider", slides);


    if (!slides.length) {

        return null;

    }

    return (

        // <HomeContainer>

            <section className="home-hero-slider">

                <Swiper

                    dir="rtl"

                    modules={[

                        Pagination,

                        Autoplay

                    ]}

                    slidesPerView={1}

                    spaceBetween={0}

                    loop={slides.length > 1}

                    pagination={{

                        clickable: true

                    }}

                    autoplay={

                        slides.length > 1

                            ? {

                                delay: 5000,

                                disableOnInteraction: false

                            }

                            : false

                    }

                    className="home-hero-slider__swiper"

                >

                    {slides.map(slide => (


                        // <SwiperSlide

                        //     key={slide.id}

                        // >

                        //     {/* your existing slide JSX */}

                        // </SwiperSlide>
                         <SwiperSlide
                            key={slide.id}
                        >

                        <article className="home-hero-slider__slide">
                            {slide.buttonUrl ? (
                                <Link
                                    to={slide.buttonUrl}
                                    className="home-hero-slider__link"
                                >
                                    <picture>
                                        {slide.mobileImage && (
                                            <source
                                                media="(max-width: 767px)"
                                                srcSet={
                                                    slide.mobileImage
                                                }
                                            />
                                        )}

                                        <img
                                            src={
                                                slide.desktopImage
                                            }
                                            alt={
                                                slide.title ||
                                                ""
                                            }
                                            className="home-hero-slider__image"

                                        />
                                    </picture>


                                </Link>
                            ) : (
                                <div className="home-hero-slider__link">
                                    <picture>
                                        {slide.mobileImage && (
                                            <source
                                                media="(max-width: 767px)"
                                                srcSet={
                                                    slide.mobileImage
                                                }
                                            />
                                        )}

                                        <img
                                            src={
                                                slide.desktopImage
                                            }
                                            alt={
                                                slide.title ||
                                                ""
                                            }
                                            className="home-hero-slider__image"
                                        />
                                    </picture>

                                    {(slide.title ||
                                        slide.subtitle) && (
                                            <div className="home-hero-slider__content">
                                                {slide.title && (
                                                    <h2>
                                                        {
                                                            slide.title
                                                        }
                                                    </h2>
                                                )}

                                                {slide.subtitle && (
                                                    <p>
                                                        {
                                                            slide.subtitle
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                </div>
                            )}
                        </article>

                         </SwiperSlide>

                    ))}

                </Swiper>

            </section>

        // </HomeContainer>

    );

}